import { FeaturedInSection } from './view';

export default FeaturedInSection;
